import { render, staticRenderFns } from "./EnterpriseDetailsLicense.vue?vue&type=template&id=65424ee2&"
import script from "./EnterpriseDetailsLicense.vue?vue&type=script&lang=js&"
export * from "./EnterpriseDetailsLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports